import { v4 as uuidv4 } from 'uuid';

export class IrisIdService {
  generate(): string {
    return uuidv4();
  }
}
